
const queryRegex = param => RegExp(`[?|&]${param}=([^&]*)`);
export default (param, query = location.search) => (query.match(queryRegex(param)) || [])[1];
